import React, { useContext, useState } from "react";

import "./GenderForm.scss";
import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";

import { isValidGender, simplyClick } from "../../helpers";
import { ContextProfileUser } from "../../lib/profileContext";
import {
  genderLabel,
  CONST_GENDER_MALE,
} from "../../constants";

function GenderForm({ nextStep }) {

  const { data, setData } = useContext(ContextProfileUser);
  const [errorGender, setErrorGender] = useState(null);
  const [genderWasChanged, setGenderWasChanged] = useState(false);

  const handlerSubmit = (e) => {
    e.preventDefault();

    if (!isValidGender(data.gender)) {
      setErrorGender("Please, choose your gender");
    } else {
      if (!genderWasChanged) {
        const currentGender = data.gender || Object.keys(genderLabel)[0];
        simplyClick("cl_lnd_i_am_choose", {
          text: genderLabel[currentGender],
        });
      }
      simplyClick("cl_lnd_i_am_next");
      nextStep();
    }
  };

  const handleAddTypeGender = ({ target: { value } }) => {
    const genderValue = value.toString();
    setData({ ...data, gender: genderValue });
    setGenderWasChanged(true);
    simplyClick("cl_lnd_i_am_choose", { text: genderLabel[genderValue] });
  };

  const options = Object.keys(genderLabel).map((key, index) => (
    <option value={key} key={`${key}_${index}`}>
      {genderLabel[key]}
    </option>
  ));

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>
        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                onChange={handleAddTypeGender}
                className="gender"
                value={data.gender || CONST_GENDER_MALE}
              >
                {options}
              </select>
            </div>
          </div>
          {errorGender && <p className="error">{errorGender}</p>}
          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
          />
          <ProgressDots total={6} activeCount={2} />
        </div>
      </form>
    </div>
  );
}

export default GenderForm;
